import axios from 'axios';
import router from '../../router'

import Step02Category from './Steps/Step02Category.js'
import Step01Recipient from './Steps/Step01Recipient.js'
import Step03ContentItems from './Steps/Step03ContentItems.js'
import Step04Sender from './Steps/Step04Sender.js'
import Step05Review from './Steps/Step05Review.js'

export default {
    namespaced: true,
    modules: {
        Step01Recipient,
        Step02Category,        
        Step03ContentItems,
        Step04Sender,
        Step05Review
    },
    state: {
        countries: [],
        localities: [],
        hsCodes: [],
        keepSender: false,
        currentStep: 1,
        declarationNumber: null,
        showSnackbar: false,
        snackbarTimeout: 3000,
        snackbarText: '',
        saving: false,
        printingLabel: false
    },
    getters: {
        currentStep: state => state.currentStep,
        currentDeclaration: (state) => {

            let currentDeclaration = {
                declarationNumber: state.declarationNumber,
                ...Step01Recipient.state,
                ...Step02Category.state,                
                ...Step04Sender.state,
                ...Step05Review.state
            };

            if (Step01Recipient.state.recipient.isRequiresContentItems) {
                currentDeclaration = { ...currentDeclaration, ...Step03ContentItems.state };
            }

            return currentDeclaration;
        },
        countries: state => state.countries,
        localities: state => state.localities,
        hsCodes: state => state.hsCodes,
        requiresContentCategoryDescription: (_, getters) => getters['Step02Category/requiresContentCategoryDescription'],
        sendingDocument: (_, getters) => {
            return getters['Step02Category/sendingDocument'];
        },
        showSnackbar: state => state.showSnackbar,
        snackbarTimeout: state => state.snackbarTimeout,
        snackbarText: state => state.snackbarText,
        saving: state => state.saving,
        printingLabel: state => state.printingLabel,
        requiresItmattForDocuments: (_, getters) => {
            
            let isItmattForDocRequired = false;

            let recipientcountryId = getters['Step01Recipient/countryId'];

            let countryArray = getters['countries'];

            if(recipientcountryId)
            {
                const country = countryArray.find(function (country) {
                    return country.id === recipientcountryId;
                  });
                
                if(country && country.code)
                {
                    isItmattForDocRequired = country.requiresItmattForDocuments;
                }
            }

            return isItmattForDocRequired;
        }
    },
    actions: {
        setSaving(context, isSaving) {
            context.commit("setSaving", isSaving)
        },
        setPrintingLabel(context, isPrintingLabel) {
            context.commit("setPrintingLabel", isPrintingLabel)
        },
        setCurrentStep(context, currentStep) {
            context.commit('setCurrentStep', currentStep);
        },
        setSnackbarVisibility(context, isSnackbarVisible) {
            context.commit('setSnackbarVisibility', isSnackbarVisible);
        },
        showRequiredEmailOrPhoneError: (context) => {
          context.commit('setSnackbarText', "Please enter at least one of email or phone number.");
          context.commit('setSnackbarVisibility', true);
        },
        async pageLoad(context) {
            await context.dispatch('getCountries');
            await context.dispatch('getLocalities');

            context.dispatch('Step02Category/resetCurrentDeclaration');
            context.dispatch('Step01Recipient/resetCurrentDeclaration');
            context.dispatch('Step03ContentItems/resetCurrentDeclaration');
            context.dispatch('Step04Sender/resetCurrentDeclaration', context.state.keepSender);
            context.dispatch('Step05Review/resetCurrentDeclaration', { currentStep: 1, declarationNumber: null });
        },
        async getCountries(context) {
            await axios.get('/Countries')
                .then((response) => {
                    context.commit("setCountries", response.data);
                }, (error) => {
                    context.commit('setSnackbarText', "An error has occurred.");
                    context.commit('setSnackbarVisibility', true);
                    console.log(error);
                });
        },
        async getLocalities(context) {
            // for developers: add the frontend url (e.g. http://localhost:8080) to the CORS origins setting
            // of your local address database api
            // e.g. <add key="CorsOrigins" value="http://localhost,http://localhost:8080" />
            await axios.get(`${process.env.VUE_APP_ADDRESS_FINDER_API_BASE_URL}${process.env.VUE_APP_ADDRESS_FINDER_API_PATH_GETALLTOWNS}`)
                .then((response) => {
                    context.commit("setLocalities", response.data);
                }, (error) => {
                    context.commit('setSnackbarText', "An error has occurred while retrieving the list of localities.");
                    context.commit('setSnackbarVisibility', true);
                    console.log(error);
                })
        },
        async getHsCodes(context) {
            await axios.get('/HSCodes')
                .then((response) => {
                    context.commit("setHsCodes", response.data);
                }, (error) => {
                    context.commit('setSnackbarText', "An error has occurred.");
                    context.commit('setSnackbarVisibility', true);
                    console.log(error);
                });
        },
        submitDeclaration(context) {
            context.commit("setSaving", true)
            const currentDeclaration = context.getters.currentDeclaration;

            const recipientCountry = context.getters.countries.find(c=> c.id === currentDeclaration.recipient.countryId);
            if (recipientCountry && !recipientCountry.requireVOEC) 
            { 
                context.dispatch('Step04Sender/resetVOECNumber');
            }

            axios.post('/CustomsOnlineLodgement', currentDeclaration)
                .then((response) => {
                    context.commit("setDeclarationNumber", response.data)
                    context.commit('setKeepSender', true);
                    router.push('/summary')
                }, (error) => {
                    context.commit('setSnackbarText', "An error has occurred.");
                    context.commit('setSnackbarTimeout', 3000);
                    context.commit('setSnackbarVisibility', true);
                    console.log(error);
                }).finally(function () {
                    context.commit("setSaving", false)
                });
        },
        startAnotherDeclarationForCurrentSender(context) { //keep the sender 
            context.commit('setKeepSender', true);
            context.commit('setCurrentStep', 1);
            router.push('/Declaration');
        },
        startAnotherDeclaration(context) {
            context.commit('setKeepSender', false);
            context.commit('setCurrentStep', 1);
            router.push('/Declaration');
        },
        printLabel(context) {
            context.commit("setPrintingLabel", true)
            const currentDeclaration = context.getters.currentDeclaration;
            axios.post('/CustomsOnlineLodgement/label', currentDeclaration, { responseType: 'arraybuffer' })
                .then((response) => {
                    //download label             
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data], {
                        type: "application/octet-stream",
                        responseType: 'arraybuffer'
                    }));
                    link.download = 'Declaration ID ' + currentDeclaration.declarationNumber + '.pdf';
                    link.dispatchEvent(new MouseEvent('click'));
                }, (error) => {
                    console.log(error);
                }).finally(function () {
                    context.commit("setPrintingLabel", false)
                });
        }
    },
    mutations: {
        setKeepSender(state, payload) {
            state.keepSender = payload;
        },
        setSnackbarText(state, payload) {
            state.snackbarText = payload;
        },
        setSnackbarVisibility(state, payload) {
            state.showSnackbar = payload;
        },
        setSnackbarTimeout(state, payload) {
            state.snackbarTimeout = payload;
        },
        setCountries(state, payload) {
            state.countries = payload;
        },
        setLocalities(state, payload) {
            state.localities = payload;
        },
        setHsCodes(state, payload) {
            state.hsCodes = payload;
        },
        setDeclarationNumber(state, number) {
            state.declarationNumber = number;
        },
        startAnotherDeclaration(state, payload) {
            state = { ...state, keepSender: payload.keepSender, currentStep: payload.currentStep };
            router.push('/Declaration');
        },
        setCurrentStep(state, payload) {
            state.currentStep = payload;
        },
        setSaving(state, payload) {
            state.saving = payload;
        },
        setPrintingLabel(state, payload) {
            state.printingLabel = payload;
        },
        resetSnackbar(state) {
            state.showSnackbar = false;
            state.snackbarText = '';
            state.snackbarTimeout = 3000;
        }
    }
}